module.exports = __webpack_public_path__ + "static/media/arrow_disabled_left.acbbe4dd.svg";